<template>
  <div class="shipping-table-container">
    <div class="table-header">
      <div class="title-section">
        <el-select
          v-model="kor_type"
          filterable
          placeholder="请选择"
          @change="queryData"
        >
          <el-option label="韩到中线路" :value="0" />
          <el-option label="韩到日线路" :value="3" />
          <el-option label="韩到马来线路" :value="4" />
          <el-option label="中到马来线路" :value="5" />
        </el-select>
        <!-- <h2>韩到马来线路</h2> -->
        <el-date-picker
          v-model="selectedMonth"
          type="month"
          placeholder="选择年月"
          format="yyyy年MM月"
          value-format="yyyy-MM"
          :clearable="false"
          :editable="false"
          @change="handleMonthChange"
        ></el-date-picker>
      </div>
      <button class="export-btn">
        <i class="export-icon"></i>
        导出本月数据
      </button>
    </div>

    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th>用户</th>
            <th>总下单数</th>
            <th>本月下单数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in userList" :key="index">
            <td class="user-cell">{{ item?.user?.nickname }}</td>
            <td>{{ item.num }}</td>
            <td class="month-orders">{{ item.month_num }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <span class="note-text">
        *注：首页仅展示前20位用户数据，请导出查看全部用户数据
      </span>
    </div>
  </div>
</template>

<script>
  import { OrderStatistics } from '@/api/xgcApi'

  export default {
    name: 'ShippingDataTable',

    data() {
      return {
        kor_type: 4,
        selectedMonth: '',
        startTime: '', // 开始时间：2026-04-01 00:00:00
        endTime: '', // 结束时间：2026-05-01 00:00:00
        userList: [
          { name: 'YH465468745', totalOrders: 1520, monthOrders: 70 },
          { name: '用户54674892134184', totalOrders: 1200, monthOrders: 65 },
          { name: '用户823213513321', totalOrders: 1100, monthOrders: 62 },
          { name: '用户897412365', totalOrders: 1000, monthOrders: 52 },
          { name: '用户303235451', totalOrders: 823, monthOrders: 50 },
          { name: '张三', totalOrders: 725, monthOrders: 48 },
          { name: '李四', totalOrders: 700, monthOrders: 45 },
          { name: '王五', totalOrders: 680, monthOrders: 42 },
          { name: '赵六', totalOrders: 650, monthOrders: 40 },
          { name: '钱七', totalOrders: 620, monthOrders: 38 },
          { name: '孙八', totalOrders: 600, monthOrders: 35 },
          { name: '周九', totalOrders: 580, monthOrders: 32 },
          { name: '吴十', totalOrders: 550, monthOrders: 30 },
          { name: '郑十一', totalOrders: 520, monthOrders: 28 },
          { name: '王十二', totalOrders: 500, monthOrders: 25 },
          { name: '冯十三', totalOrders: 480, monthOrders: 22 },
          { name: '陈十四', totalOrders: 450, monthOrders: 20 },
          { name: '褚十五', totalOrders: 420, monthOrders: 18 },
          { name: '卫十六', totalOrders: 400, monthOrders: 15 },
          { name: '蒋十七', totalOrders: 380, monthOrders: 12 },
        ],
        allUsers: [], // 存储所有用户数据
      }
    },
    computed: {},

    mounted() {
      // 获取当前年月
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() + 1
      const defaultMonth = `${currentYear}-${String(currentMonth).padStart(
        2,
        '0'
      )}`
      this.selectedMonth = defaultMonth

      // 初始化计算当前月份的时间范围
      this.calculateMonthRange(this.selectedMonth)
      // 初始化加载数据
      this.queryData()

      console.log(this.selectedMonth, 'selectedMonth')
    },

    methods: {
      exportData() {
        // 导出数据逻辑
        console.log('导出本月数据')
      },

      /**
       * 格式化日期时间为 YYYY-MM-DD HH:mm:ss
       */
      formatDateTime(date) {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const h = String(date.getHours()).padStart(2, '0')
        const min = String(date.getMinutes()).padStart(2, '0')
        const s = String(date.getSeconds()).padStart(2, '0')
        return `${y}-${m}-${d} ${h}:${min}:${s}`
      },

      /**
       * 根据年月计算时间范围
       * @param {string} yearMonth - 格式：'YYYY-MM'，如 '2026-04'
       * 开始时间：2026-04-01 00:00:00
       * 结束时间：2026-05-01 00:00:00
       */
      calculateMonthRange(yearMonth) {
        if (!yearMonth) return null

        // 解析年月
        const [year, month] = yearMonth.split('-').map(Number)

        // 开始时间：当月1号 00:00:00
        const startDate = new Date(year, month - 1, 1, 0, 0, 0)

        // 结束时间：下个月1号 00:00:00
        const endDate = new Date(year, month, 1, 0, 0, 0)

        this.startTime = this.formatDateTime(startDate)
        this.endTime = this.formatDateTime(endDate)

        console.log('时间范围:', this.startTime, '至', this.endTime)

        return {
          startTime: this.startTime,
          endTime: this.endTime,
        }
      },

      /**
       * 线路切换时的回调
       */
      handleLineChange(value) {
        console.log('切换线路:', value)
        this.queryData()
      },

      /**
       * 月份变化时的回调
       */
      handleMonthChange(value) {
        if (value) {
          this.selectedMonth = value
          this.calculateMonthRange(value)
          this.queryData()
        }
      },

      /**
       * 查询数据
       */
      queryData() {
        var data = {
          start_time: this.startTime, //开始时间查看后面月份的时间
          end_time: this.endTime, //结束时间
          kor_type: this.kor_type, //0韩到中 3韩到日 4韩到马来 5中到马来
        }
        OrderStatistics(data).then((res) => {
          console.log(res, 'res')
          this.userList = res.data
        })

        // 获取线路名称
        // const lineName = this.getLineName(this.kor_type)
        // console.log(`查询 ${lineName} ${this.selectedMonth} 的数据`)        console.log(`时间范围: ${this.startTime} 至 ${this.endTime}`)
        // 显示加载状态
        // this.$loading({
        //   text: '加载中...',
        //   spinner: 'el-icon-loading',
        // })
        // 模拟API请求
        // setTimeout(() => {
        //   console.log('查询参数:', {
        //     lineType: this.kor_type,
        //     lineName: this.getLineName(this.kor_type),
        //     month: this.selectedMonth,
        //     startTime: this.startTime,
        //     endTime: this.endTime
        //   })
        //   this.$loading().close()
        //   this.$message.success('数据加载成功')
        // }, 500)
      },
    },
  }
</script>

<style scoped langs="scss">
  ::v-deep .el-input__inner {
    background: #f7f8fc;
    border: none;
    color: #5470c6;
    font-size: 18px;
    width: 166px;
  }
  .shipping-table-container {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, sans-serif;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.04);
    padding: 24px 28px;
    max-width: 1200px;
    margin: 0 auto;
    transition: all 0.3s ease;
  }

  /* 头部区域 */
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
  }

  .title-section {
    display: flex;
    align-items: baseline;
    gap: 16px;
    flex-wrap: wrap;
  }

  .title-section h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1f2d3d;
    letter-spacing: -0.2px;
    background: linear-gradient(135deg, #1f2d3d 0%, #2c3e50 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .date-badge {
    background-color: #f0f2f5;
    padding: 6px 14px;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    letter-spacing: 0.3px;
    border: 1px solid #e4e7ed;
    backdrop-filter: blur(2px);
  }

  /* 导出按钮 */
  .export-btn {
    /* background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);s */
    background: #5470c6;
    border: none;
    padding: 10px 24px;
    border-radius: 4px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(24, 144, 255, 0.2);
  }

  .export-btn:hover {
    background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%);
    transform: translateY(-1px);
    box-shadow: 0 6px 12px rgba(24, 144, 255, 0.25);
  }

  .export-btn:active {
    transform: translateY(1px);
  }

  .export-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'/%3E%3C/svg%3E")
      no-repeat center;
    background-size: contain;
    filter: brightness(0) invert(1);
  }

  /* 表格包装器 - 响应式滚动 */
  .table-wrapper {
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid #eef2f6;
    background-color: #fff;
    margin-bottom: 20px;
  }

  /* 表格样式 */
  .data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    min-width: 560px;
  }

  .data-table thead tr {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-bottom: 1px solid #e2e8f0;
  }

  .data-table th {
    text-align: left;
    padding: 16px 20px;
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
    letter-spacing: 0.3px;
    border-bottom: 1px solid #e2e8f0;
    background-color: #f8fafc;
  }

  .data-table td {
    padding: 14px 20px;
    border-bottom: 1px solid #f0f2f5;
    color: #334155;
    font-weight: 450;
    transition: background-color 0.2s ease;
  }

  .data-table tbody tr:hover {
    background-color: #fafcff;
    box-shadow: inset 0 0 0 1px #e6f0ff;
  }

  .data-table tbody tr:last-child td {
    border-bottom: none;
  }

  /* 特殊列样式 */
  .user-cell {
    font-family: 'SF Mono', 'Menlo', monospace;
    font-weight: 500;
    color: #0f172a;
    letter-spacing: 0.2px;
  }

  .month-orders {
    /* font-weight: 600;
    color: #1890ff;
    background-color: #f0f9ff;
    border-radius: 20px;
    width: fit-content;
    padding: 4px 12px;
    display: inline-block;
    line-height: 1.4; */
  }

  /* 让本月下单数字母显示更明显 */
  .data-table td:nth-child(3) {
    font-weight: 600;
  }

  /* 表格底部备注 */
  .table-footer {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px dashed #e4e7eb;
  }

  .note-text {
    font-size: 12px;
    color: #8a99b4;
    background: #f9fafc;
    padding: 6px 12px;
    border-radius: 8px;
    display: inline-block;
    letter-spacing: 0.2px;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .shipping-table-container {
      padding: 16px 18px;
      border-radius: 12px;
    }

    .title-section h2 {
      font-size: 20px;
    }

    .export-btn {
      padding: 7px 18px;
      font-size: 13px;
    }

    .data-table th,
    .data-table td {
      padding: 12px 16px;
    }

    .month-orders {
      padding: 2px 10px;
    }
  }

  /* 优雅的滚动条 */
  .table-wrapper::-webkit-scrollbar {
    height: 8px;
  }

  .table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .table-wrapper::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  .table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
</style>
